import { isPlatform } from "@ionic/core";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import { iosCustomTransitionAnimation } from "@/functions/animation";

import { IonicConfig } from "@/types/ionic";

export const getCustomConfig = (): IonicConfig => {
    const config: IonicConfig = {}

    if (isPlatform('ios')) config.navAnimation = iosCustomTransitionAnimation
    if (isPlatform('ios')) config.swipeBackEnabled = false;

    return config
}
